import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { RenderModule } from 'holocron';
import { useHolocronState } from '../hooks/useHolocronState';
import constants from '../utils/constants';

const GlobalNavigationWrapper = ({ children }) => {
  const state = useHolocronState();
  const loadedHolocrons = state.getIn(['holocron', 'loaded']);
  const isGlobalHeaderLoaded = loadedHolocrons.includes('axp-global-header');
  const isGlobalFooterLoaded = loadedHolocrons.includes('axp-footer');

  const isNavNonSticky = constants.nonStickyModules.some((module) => loadedHolocrons.has(module));
  const [showFooter, setShowFooter] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && 'requestIdleCallback' in window) {
      const idleId = window.requestIdleCallback(() => setShowFooter(true), { timeout: 2000 });
      return () => window.cancelIdleCallback(idleId);
    }

    const timeoutId = window.setTimeout(() => setShowFooter(true), 0);
    return () => window.clearTimeout(timeoutId);
  }, []);

  return (
    <>
      {isGlobalHeaderLoaded ? (
        <RenderModule
          props={{
            isNavNonSticky,
          }}
          moduleName="axp-global-header"
        />
      ) : null}

      {children}
      {isGlobalFooterLoaded && showFooter ? <RenderModule moduleName="axp-footer" /> : null}
    </>
  );
};

GlobalNavigationWrapper.propTypes = {
  children: PropTypes.node,
  route: PropTypes.shape({
    store: PropTypes.shape({
      getState: PropTypes.func,
    }),
  }),
};

GlobalNavigationWrapper.defaultProps = {
  children: null,
};

export default GlobalNavigationWrapper;
